import { getColor, getSize } from "../../resources/theme";
import { useHistory } from "react-router-dom";
import HpIcon, { Icons } from "react-hp-icons";
import React, { useDispatch, useGlobal, useState } from "reactn";
import onClickOutside from "react-onclickoutside";
import styled from "styled-components";

const clickOutsideConfig = {
	handleClickOutside: () => SearchSuggestions.handleClickOutside,
};

// must be declared with the function keyword in order the onClickOutside to work
function SearchSuggestions({
	results = [],
	resetSearch,
	tempCategory,
	suggestionsOpenable,
	setSuggestionsOpenable,
}) {
	const history = useHistory();
	const addCategoryFilter = useDispatch("addCategoryFilter");
	SearchSuggestions.handleClickOutside = () => setSuggestionsOpenable(false);

	return (
		suggestionsOpenable && (
			<BoxResult>
				{!!results.length && !!tempCategory && !!tempCategory.name && (
					<BoxResultItem
						onClick={() => {
							const category = tempCategory;
							addCategoryFilter({ category }).then(() => {
								history.push(
									`/search?category=${tempCategory.slug}`
								);
								resetSearch();
							});
						}}
					>
						<h4>Buscar todos: {tempCategory.name}</h4>
					</BoxResultItem>
				)}
				{!!results.length &&
					results.map(({ name, slug }, i) => (
						<BoxResultItem
							key={i}
							onClick={() => {
								history.push(`/offices/${slug}`);
								resetSearch();
							}}
						>
							<span>{name}</span>
							<HpIcon type={Icons.right} size={1} />
						</BoxResultItem>
					))}
				{!results.length && (
					<BoxResultItem>Sin resultados</BoxResultItem>
				)}
			</BoxResult>
		)
	);
}

export default onClickOutside(SearchSuggestions, clickOutsideConfig);

const BoxResult = styled.div`
	padding: ${getSize("s")};
	background: #fff;
	border-radius: 10px;
`;

const BoxResultItem = styled.div`
	background: #fff;
	color: #000000;
	border-bottom: 1px solid #dedede;
	padding: 10px 5px;
	display: inline-block;
	width: 100%;
	box-sizing: border-box;
	span {
		float: left;
	}

	.ripple {
		float: right;
	}

	&:hover {
		background: ${getColor("bg_alt")};
		border-radius: 10px;
		cursor: pointer;
	}
	&:last-child {
		border: none;
	}
`;
